<template>
  <v-card flat>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="caption">Run</td>
              <td class="caption">{{ ((info.run / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.run / 100).toFixed(2) }} m</td>
            </tr>
            <tr>
              <td class="caption">Walk</td>
              <td class="caption">{{ ((info.walk / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.walk / 100).toFixed(2) }} m</td>
            </tr>
            <tr>
              <td class="caption">Boat</td>
              <td class="caption">{{ ((info.boat / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.boat / 100).toFixed(2) }} m</td>
            </tr>
            <tr>
              <td class="caption">Dodge</td>
              <td class="caption">{{ ((info.dodge / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.dodge / 100).toFixed(2) }} m</td>
            </tr>
            <tr>
              <td class="caption">Aim</td>
              <td class="caption">{{ ((info.aim / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.aim / 100).toFixed(2) }} m</td>
            </tr>
            <tr>
              <td class="caption">Flashlight</td>
              <td class="caption">{{ ((info.flashlight / (info.players || 1)) / 100).toFixed(2) }} m</td>
              <td class="caption">{{ (info.flashlight / 100).toFixed(2) }} m</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      info: {
        run: 0,
        walk: 0,
        boat: 0,
        dodge: 0,
        aim: 0,
        flashlight: 0,
        players: 0
      }
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-movement`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    }
  }
}
</script>